import React, { useState, useEffect, Fragment } from "react";
import HeaderAll from "../../HeaderAll";

function HeaderVo(props) {
  const { info,onUnmountComplete } = props;
  return (
    <Fragment>
      <HeaderAll Report={false}  found={info} />

    </Fragment>
  );
}
export default HeaderVo;
